var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "magic-zoom" } },
    [
      _vm.reducedSpecial != "none"
        ? [
            _vm.reducedSpecial == "special"
              ? [
                  _c("div", { staticClass: "phywe-aktion-wrapper" }, [
                    _vm.$store.getters.currentItemVariation.item.storeSpecial
                      .id === 1
                      ? _c("div", { staticClass: "phywe-aktion" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.storeSpecialOffer"
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm.$store.getters.currentItemVariation.item
                          .storeSpecial.id === 2
                      ? _c("div", { staticClass: "phywe-aktion" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.storeSpecialNew"
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm.$store.getters.currentItemVariation.item
                          .storeSpecial.id === 3
                      ? _c("div", { staticClass: "phywe-aktion" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.storeSpecialTop"
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      : _vm._e()
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.reducedSpecial == "reduced" ? [_vm._m(0)] : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { itemscope: "", itemtype: "http://schema.org/Thing" } },
        [
          _c(
            "div",
            {
              staticClass: "ItemImgWrap justify-content-center mt-3 mt-md-0",
              class: { "more-images": _vm.magiczoom.images.all.length > 0 }
            },
            [
              _c(
                "a",
                {
                  staticClass:
                    "MagicZoomPlus flex-fill d-flex align-items-start justify-content-center",
                  attrs: {
                    href: _vm._f("itemImage")(
                      _vm._f("itemImages")(_vm.magiczoom.images, "url")
                    ),
                    id: "ItemImgZoom",
                    "data-mobile-options":
                      "zoomMode:off; lazyZoom: true; textTouchZoomHint:" +
                      _vm.$translate("Phywe::Template.singleZoomHint") +
                      "; textClickZoomHint: " +
                      _vm.$translate("Phywe::Template.singleZoomHint2") +
                      "; textExpandHint: " +
                      _vm.$translate("Phywe::Template.singleZoomHint"),
                    "data-options":
                      "lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:" +
                      _vm.$translate("Phywe::Template.singleZoomHint3") +
                      "; textExpandHint:" +
                      _vm.$translate("Phywe::Template.singleZoomHint3") +
                      "; zoomPosition: #zoom-placeholder;"
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: {
                      src: _vm._f("itemImage")(
                        _vm._f("itemImages")(_vm.magiczoom.images, "url")
                      ),
                      itemprop: "image"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.magiczoom.images.all.length > 0
                ? [
                    _vm.magiczoom.images.all.length >= 4
                      ? _c(
                          "div",
                          {
                            staticClass: "magic-more-images d-none d-lg-block"
                          },
                          [
                            _vm.magiczoom.images.all.length > 4
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "hooper-icons up",
                                    on: { click: _vm.slidePrev }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-up",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "hooper",
                              {
                                ref: "carousel",
                                staticClass: "d-none d-lg-block",
                                attrs: {
                                  vertical: true,
                                  infiniteScroll: false,
                                  itemsToShow: 4,
                                  trimWhiteSpace: true
                                }
                              },
                              [
                                _vm.hasVideo
                                  ? _c("slide", [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "border video d-flex mb-2 videoImage cursor",
                                          on: {
                                            click: function($event) {
                                              return _vm.showVideo()
                                            }
                                          }
                                        },
                                        [
                                          !_vm.loading
                                            ? _c("i", {
                                                staticClass:
                                                  "fa fa-play-circle-o"
                                              })
                                            : _c("i", {
                                                staticClass:
                                                  "fa fa-circle-o-notch fa-spin"
                                              })
                                        ]
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(_vm.magiczoom.images.all, function(
                                  imagePreview,
                                  index
                                ) {
                                  return _c("slide", { key: index }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "border",
                                        attrs: {
                                          href:
                                            _vm.magiczoom.images.all[index].url,
                                          rel: "zoom-id:ItemImgZoom",
                                          "data-image":
                                            _vm.magiczoom.images.all[index].url
                                        }
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            "data-src": imagePreview.url,
                                            src: imagePreview.urlPreview
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.magiczoom.images.all.length > 4
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "hooper-icons down",
                                    on: { click: _vm.slideNext }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-chevron-down",
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "magic-more-images d-none d-lg-block"
                          },
                          [
                            _vm.hasVideo
                              ? [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "border video d-flex mb-2 videoImage",
                                      on: {
                                        click: function($event) {
                                          return _vm.showVideo()
                                        }
                                      }
                                    },
                                    [
                                      !_vm.loading
                                        ? _c("i", {
                                            staticClass: "fa fa-play-circle-o"
                                          })
                                        : _c("i", {
                                            staticClass:
                                              "fa fa-circle-o-notch fa-spin"
                                          })
                                    ]
                                  )
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.magiczoom.images.all, function(
                              imagePreview,
                              index
                            ) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "mb-2 border",
                                    attrs: {
                                      href: _vm.magiczoom.images.all[index].url,
                                      rel: "zoom-id:ItemImgZoom",
                                      "data-image":
                                        _vm.magiczoom.images.all[index].url
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        "data-src": imagePreview.url,
                                        src: imagePreview.urlPreview
                                      }
                                    })
                                  ]
                                )
                              ]
                            })
                          ],
                          2
                        )
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "zoom-navigation-dots d-md-none" })
        ]
      ),
      _vm._v(" "),
      _vm.hasVideo
        ? _c("div", { attrs: { id: "video-modal-wrapper" } }, [
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: { id: "video-modal", tabindex: "-1", role: "dialog" },
                on: {
                  hidden: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k(
                        $event.keyCode,
                        "bs",
                        undefined,
                        $event.key,
                        undefined
                      ) &&
                      _vm._k(
                        $event.keyCode,
                        "modal",
                        undefined,
                        $event.key,
                        undefined
                      )
                    ) {
                      return null
                    }
                    return _vm.stopVideo($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "modal-dialog" }, [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("div", { staticClass: "modal-title h4" }, [
                        _vm._v("Video")
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              return _vm.closeVideo()
                            }
                          }
                        },
                        [_vm._v("×")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _vm.showvid
                        ? _c(
                            "div",
                            { staticClass: "video-container" },
                            [
                              _vm.videoList.length > 0
                                ? _vm._l(_vm.videoList, function(url, idx) {
                                    return _c("iframe", {
                                      key: idx,
                                      staticClass: "mb-4",
                                      attrs: {
                                        width: "100%",
                                        height: "315",
                                        src: _vm.normalizedVideoUrl(url),
                                        title: "Video",
                                        frameborder: "0",
                                        allow:
                                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                        allowfullscreen: ""
                                      }
                                    })
                                  })
                                : [
                                    _c("iframe", {
                                      attrs: {
                                        width: "100%",
                                        height: "315",
                                        src:
                                          "https://www.youtube-nocookie.com/embed/" +
                                          _vm.video,
                                        title: "Video",
                                        frameborder: "0",
                                        allow:
                                          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                        allowfullscreen: ""
                                      }
                                    })
                                  ]
                            ],
                            2
                          )
                        : _vm._e()
                    ])
                  ])
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "reduced" }, [_c("span", [_vm._v("%")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }